import WCAG from './wcag'

class WCAGHeader {
  static focusedElementIsInsideMainMenu = (): boolean => {
    const focusedElement = WCAG.getFocusedElement()

    if (!focusedElement) return false
    return focusedElement.classList.contains('main-menu__button')
  }

  static focusedElementIsInsideSubmenu = (): boolean => {
    const focusedElement = WCAG.getFocusedElement()
    if (!focusedElement) return false

    const focusedElementIsTermsAndConditions = focusedElement.matches('.rb-terms-and-conditions a')

    const focusedElementIsSubmenuItem = focusedElement.matches(
      '.rb-header__submenu .section__item a'
    )
    const focusedElementIsInsideEditorial = focusedElement.matches(
      '.rb-header__submenu .editorial__container .product-slide a, .rb-header__submenu .editorial__container .carousel__controls span, .wall__banner > a'
    )

    return (
      focusedElementIsSubmenuItem ||
      focusedElementIsInsideEditorial ||
      focusedElementIsTermsAndConditions
    )
  }

  static focusedElementIsLastItemInsideSubmenuWithEditorial = (): boolean => {
    if (!this.focusedElementIsInsideSubmenu()) return false

    const focusedElement = WCAG.getFocusedElement()
    if (!focusedElement) return false

    const lastBannerCta = focusedElement.matches(
      '.editorial__container .editorial-wall .wall__banner .rb-banner .text-module__cta-container a:last-child'
    )
    if (lastBannerCta) return true

    const hasBanner = focusedElement.matches(
      '.editorial__container .wall__elements.wall__elements--with-banner > .wall__products.wall__products > .product-slide:last-child > a'
    )
    const lastEditorialWallProduct = focusedElement.matches(
      '.editorial__container .wall__elements.wall__elements > .wall__products.wall__products > .product-slide:last-child > a'
    )
    if (lastEditorialWallProduct && !hasBanner) {
      return true
    }

    const lastEditorialWallProductWithBanner = focusedElement.matches(
      '.editorial__container .editorial-wall .wall__banner a:last-child'
    )
    if (lastEditorialWallProductWithBanner) {
      return true
    }

    // TODO: handle case on promos with banner
    return focusedElement.matches(
      '.editorial__container .carousel__slides .swiper-slide:last-child a'
    )
  }

  static focusedElementIsLastItemInsideSubmenuWithoutEditorial = (): boolean => {
    if (!this.focusedElementIsInsideSubmenu()) return false

    const focusedElement = WCAG.getFocusedElement()
    if (!focusedElement) return false

    const sectionItemInsidePromos = focusedElement.matches(
      '.submenu__section:last-child div:last-child a'
    )

    if (sectionItemInsidePromos) return true

    return focusedElement.matches('.submenu__section:last-child > .section__item:last-child a')
  }
}

export default WCAGHeader
